var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',{attrs:{"menu-items":_vm.dashboardRoutesBaseOnAccess()}},[_c('div',{staticClass:"text-dashboard border shadow-sm mt-3 w-100 h-auto"},[_c('m-update-site-message-1'),_c('router-view',{attrs:{"name":"dashboard"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }